import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useContext, useReducer, useEffect } from 'react';
import { SSEContext } from './SSEContext';
export function useSSE(eventName, initialState, options) {
  var _ref = options || {},
      _ref$stateReducer = _ref.stateReducer,
      stateReducer = _ref$stateReducer === void 0 ? function (_, action) {
    return action.data;
  } : _ref$stateReducer,
      _ref$parser = _ref.parser,
      parser = _ref$parser === void 0 ? function (data) {
    return JSON.parse(data);
  } : _ref$parser,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? SSEContext : _ref$context;

  var source = useContext(context);

  var _useReducer = useReducer(stateReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  if (!source) {
    throw new Error('Could not find an SSE context; You have to wrap useSSE() in a <SSEProvider>.');
  }

  useEffect(function () {
    var listener = function listener(event) {
      var data = parser(event.data);
      dispatch({
        event: event,
        data: data
      });
    };

    source.addEventListener(eventName, listener);
    return function () {
      source.removeEventListener(eventName, listener);
    };
  }, []);
  return state;
}